import { useSheet } from '@shared/hooks/use-sheet'
import { SideSheet } from 'v2/shared/components/side-sheet'
import type { WebsiteScraperFormValues } from '../../types'
import { DocumentContent } from './document-content'

export const PreviewSheet = () => {
  const { sheetData } = useSheet<WebsiteScraperFormValues['links'][0]>()
  return (
    <SideSheet title="Preview">
      <DocumentContent content={sheetData?.markdown ?? ''} />
    </SideSheet>
  )
}
